import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageRC0008 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran:any
}
/* @ngInject */
export default function Rc0008Controller(
    Menu: IMenuClass, 
    MenuItemEcran: IMenuItemEcranClass,
     ecranDetails: IEcranDetailsResourcesEntite,
    rc2002Route: IRoute,
    rc0007Route: IRoute,
    rc0006Route: IRoute
) {
    const vm: IPageRC0008 = this;
    vm.valeursEcran = ecranDetails.valeurs; 
    vm.multiOccurrenceOptions = {
        navigatePage:  (rowData: any) =>  vm.valeursEcran.ouvr_displ &&  getForageItem(rowData),
        actionsNouveaux: new Menu([
            new MenuItemEcran( 
                '', 
                rc2002Route.NAME,
                () => ({}),
                {
                    iconButton: false,
                    icon: 'add_circle',
                    fonction:'BLC_FNC_NOUV',
                    disabled:  !vm.valeursEcran.nouv_displ
                }
            )
        ]),
        fonctions: {
            rechercheCollapsable: false,
            selectionCycle:false
        },
        colonnesFixesGauche: [
            { nom: 'txmnumdoc', largeur: 100 },
            { nom: 'txmnumdocseq', largeur: 80 },
            { nom: 'docaffsysboncmd01', largeur: 130 },
            { nom: 'tydcod', largeur: 100 },
            { nom: 'docaffnumdoc01', largeur: 140 },
        ],
        colonnesVisibles: [
            { nom: 'tydcodref', largeur: 100 },
            { nom: 'tyddscref', largeur: 180 },
            { nom: 'etddsc', largeur: 130 },
            { nom: 'peccod', largeur: 80 },
            { nom: 'intcodreq', largeur: 120 },
            { nom: 'intnomreq', largeur: 180 }
        ],
        colonnesCachees:['tydcleint']
    };
    // fonction qui retourne le forage 
    function getForageItem(rowData: any): string{
     if (rowData.tydcleint === 149 )
     {
       return rc0006Route.NAME; 
      } else {
       return rc0007Route.NAME; 
    }
}
}

